import { EVENTS, subscribe } from 'ia-util-pubsub'

/* IA Payment Installments — <ia-payment-installments> inside the PDP payment
   options modal (snippets/ia-payment-modal.liquid).

   Shop Pay's <shopify-payment-terms> is rendered straight into the modal by
   Liquid, so it needs nothing here. Afterpay's <square-placement> can't be:
   it belongs to the Afterpay on-site-messaging APP (a theme app extension the
   merchant drops onto the product template), so the theme has no way to emit
   it. This clones the app's element into the modal cell, which re-upgrades it
   and lets the vendor script render the amount and own its own info popup.

   The app block is hidden everywhere (ia-custom.css) and
   swapped for fresh section HTML on variant:change by <ia-pdp> (ia-pdp.js)
   before the buy block, so this element re-connects and clones the new
   amount; the variant:change subscription covers modals that are not
   re-rendered. The cell keeps a static fallback until a real widget lands,
   so stores without the app (or Shop Pay Installments) still show
   something sensible. Bundle builders total client-side and publish
   bundle:change (ia-bundle.js): the Afterpay clone re-renders from
   data-amount, as the app's own variant sync does; Shop Pay's terms are
   per-variant and cannot follow. */
class IaPaymentInstallments extends HTMLElement {
  connectedCallback() {
    // Not `this.slot`: that is Element.slot (reflects the slot attribute) and stringifies the node.
    this.widgetSlot = this.querySelector('[data-afterpay-slot]')
    this.cell = this.querySelector('[data-afterpay-cell]')
    if (!this.widgetSlot) return

    this.syncAfterpay()
    this.unsubscribers = [
      subscribe(EVENTS.variantChange, this.syncAfterpay.bind(this)),
      subscribe(EVENTS.bundleChange, this.handleBundleChange.bind(this))
    ]
  }

  disconnectedCallback() {
    this.unsubscribers?.forEach((unsubscribe) => unsubscribe())
  }

  handleBundleChange({ detail }) {
    if (detail.blockId !== this.dataset.owner || !(detail.total > 0)) return
    this.bundleAmount = (detail.total / 100).toFixed(2)
    this.applyBundleAmount(this.widgetSlot.firstElementChild)
  }

  applyBundleAmount(widget) {
    if (this.bundleAmount && widget) widget.setAttribute('data-amount', this.bundleAmount)
  }

  syncAfterpay() {
    /* Skip our own clone — the modal can precede the app block in the DOM. */
    const source = [...document.querySelectorAll('square-placement')].find((el) => !this.contains(el))
    if (!source) return
    // Shallow clone re-upgrades from scratch; drop the id so the app's own variant sync keeps targeting the source.
    const widget = source.cloneNode(false)
    widget.removeAttribute('id')
    this.applyBundleAmount(widget)
    this.widgetSlot.textContent = ''
    this.widgetSlot.appendChild(widget)
    this.cell?.classList.add('has-widget')
  }
}

customElements.define('ia-payment-installments', IaPaymentInstallments)
